import React, { useState } from "react";
import MarketingLayout from "@/components/marketing/MarketingLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", { ...form, kind: "contact" });
      toast.success("Message received - we'll respond within a few hours during staffed time.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MarketingLayout>
      <section className="pt-28 pb-12 max-w-5xl mx-auto px-6 lg:px-10">
        <p className="text-xs uppercase tracking-[0.2em] text-[#2C6BAC] font-semibold mb-4">Contact</p>
        <h1 className="font-display text-5xl lg:text-6xl tracking-tighter text-[#1A1A2E] leading-[0.95]">
          Tell us what's on your mind.
        </h1>
      </section>

      <section className="max-w-3xl mx-auto px-6 lg:px-10 pb-12">
        <form onSubmit={submit} className="rounded-xl border border-[#E8ECF2] bg-white p-8 space-y-5" data-testid="contact-form">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div>
              <Label htmlFor="name">Name</Label>
              <Input id="name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required data-testid="contact-name" />
            </div>
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required data-testid="contact-email" />
            </div>
          </div>
          <div>
            <Label htmlFor="subject">Subject</Label>
            <Input id="subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} data-testid="contact-subject" />
          </div>
          <div>
            <Label htmlFor="message">Message</Label>
            <Textarea id="message" rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} required data-testid="contact-message" />
          </div>
          <Button disabled={loading} className="bg-[#2C6BAC] hover:bg-[#1A3A5C] text-white" data-testid="contact-submit">
            {loading ? "Sending…" : "Send message"}
          </Button>
        </form>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="rounded-xl border border-[#E8ECF2] bg-white p-5">
            <p className="text-xs uppercase tracking-[0.18em] text-[#2C6BAC] font-semibold">Existing user?</p>
            <p className="text-sm text-[#555568] mt-2">Log in for live chat support inside the app.</p>
          </div>
          <div className="rounded-xl border border-[#E8ECF2] bg-white p-5">
            <p className="text-xs uppercase tracking-[0.18em] text-[#2C6BAC] font-semibold">Investor enquiries</p>
            <a href="mailto:investor.interest@usewylo.com" className="text-sm text-[#1A3A5C] hover:underline mt-2 inline-block">
              investor.interest@usewylo.com
            </a>
          </div>
          <div className="rounded-xl border border-[#E8ECF2] bg-white p-5">
            <p className="text-xs uppercase tracking-[0.18em] text-[#2C6BAC] font-semibold">Support</p>
            <a href="mailto:support@usewylo.com" className="text-sm text-[#1A3A5C] hover:underline mt-2 inline-block">
              support@usewylo.com
            </a>
          </div>
          <div className="rounded-xl border border-[#E8ECF2] bg-white p-5" data-testid="contact-legal">
            <p className="text-xs uppercase tracking-[0.18em] text-[#2C6BAC] font-semibold">Legal enquiries</p>
            <a href="mailto:legal@usewylo.com" className="text-sm text-[#1A3A5C] hover:underline mt-2 inline-block">
              legal@usewylo.com
            </a>
          </div>
          <div className="rounded-xl border border-[#E8ECF2] bg-white p-5" data-testid="contact-finance">
            <p className="text-xs uppercase tracking-[0.18em] text-[#2C6BAC] font-semibold">Finance team</p>
            <a href="mailto:finance@usewylo.com" className="text-sm text-[#1A3A5C] hover:underline mt-2 inline-block">
              finance@usewylo.com
            </a>
          </div>
          <div className="rounded-xl border border-[#E8ECF2] bg-white p-5" data-testid="contact-hr">
            <p className="text-xs uppercase tracking-[0.18em] text-[#2C6BAC] font-semibold">People &amp; culture</p>
            <a href="mailto:hr@usewylo.com" className="text-sm text-[#1A3A5C] hover:underline mt-2 inline-block">
              hr@usewylo.com
            </a>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
